import {
  LOGGEDIN,
  MISSING_MODAL,
  PUSH_NOTIF_MODAL,
  SET_INVITATION,
  ADD_INVITATION,
  SET_NEWTENANTS,
  SET_NEWADS,
  SET_SELECTEDROOM,
  SET_NREAD,
  SET_STEP,
  SET_INAPP_WARNING,
  RESET_REDUX,
  SET_CITIES,
} from "@/constants/action-general-types";

import type { IInvitation, IUser, IAdvertise, ICity } from "@/types";

// Action creators
export const setLoggedIn = () => ({ type: LOGGEDIN, payload: {} } as const);

export const setMissingDataModal = () =>
  ({ type: MISSING_MODAL, payload: {} } as const);

export const setPushNotifModal = () =>
  ({ type: PUSH_NOTIF_MODAL, payload: {} } as const);

export const setInvitation = (invitationList: IInvitation) =>
  ({
    type: SET_INVITATION,
    payload: invitationList,
  } as const);

export const addInvitation = (ads_id: string, invitation: any) =>
  ({
    type: ADD_INVITATION,
    payload: { ads_id, invitation },
  } as const);

export const setNewTenants = (users: IUser[], count: number) =>
  ({
    type: SET_NEWTENANTS,
    payload: { users, count },
  } as const);

export const setNewAds = (
  ads: Array<{ advertise: IAdvertise; [key: string]: any }>
) =>
  ({
    type: SET_NEWADS,
    payload: ads,
  } as const);

export const setCities = (cities: ICity[]) =>
  ({
    type: SET_CITIES,
    payload: cities,
  } as const);

export const setSelectedRoom = (id: number) =>
  ({
    type: SET_SELECTEDROOM,
    payload: id,
  } as const);

export const setNread = (nread: number) =>
  ({
    type: SET_NREAD,
    payload: nread,
  } as const);

export const setStep = (step: number) =>
  ({
    type: SET_STEP,
    payload: step,
  } as const);

export const setInappWarning = (read: boolean) =>
  ({
    type: SET_INAPP_WARNING,
    payload: read,
  } as const);

export const resetRedux = () => ({ type: RESET_REDUX, payload: {} } as const);
